import axios from "axios";
import config from "../config";

export const getFaqsCedula = async () => {
  try {
    const data = await axios.get(`${config.serverUrl}/faqs/cedulas`);

    return data;
  } catch (error) {
    console.error(error.message);
    return null;
  }
};

export const getFaqsReports = async () => {
  try {
    const data = await axios.get(`${config.serverUrl}/faqs/reports`);

    return data;
  } catch (error) {
    console.error(error.message);
    return null;
  }
};
